import React from "react";
import MuiButton from "@material-ui/core/Button";
import OpenInNewIcon from "@material-ui/icons/OpenInNew";
import styled from "@material-ui/core/styles/styled";
import pxToRem from "libs/pxToRem";
import environment from "environment";

const VerOperacionEuro: React.FC<{ operacionId: number }> = ({
  operacionId,
}) => {
  const handleClick = () => {
    const url = `${environment.euroWebUrl}/webpages/gcvistacreditoconsumo.aspx?id=${operacionId}`;
    window.open(url, "_blank", "noopener,noreferrer");
  };

  return (
    <Button onClick={handleClick} endIcon={<OpenInNewIcon />}>
      Ver en Euro
    </Button>
  );
};

export default VerOperacionEuro;

const Button = styled(MuiButton)({
  height: pxToRem(28),
  marginLeft: pxToRem(8),
  whiteSpace: "nowrap",
});
Button.defaultProps = {
  variant: "contained",
  color: "secondary",
  size: "small",
};
